/* AB GCA-043-SW-CVR, RPV | Main Menu by Car Model - JavaScript */

(function() {
  'use strict';

  /**
   * Models Menu Controller
   * - Calculates and sets header height for dropdown positioning
   * - Handles mobile accordion toggle behavior
   */
  class ModelsMenuController {
    constructor() {
      this.setHeaderHeight();
      this.bindDelegatedClicks();
      this.bindResize();
    }

    /**
     * Calculate and set --models-dropdown-top CSS variable
     * based on actual header height
     */
    setHeaderHeight() {
      const header = document.querySelector('.header-wrapper');
      if (header) {
        const rect = header.getBoundingClientRect();
        const topOffset = rect.bottom;
        document.documentElement.style.setProperty('--models-dropdown-top', `${topOffset}px`);
      }
    }

    bindResize() {
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => this.setHeaderHeight(), 100);
      });
      
      // Also recalculate on scroll for sticky headers
      window.addEventListener('scroll', () => {
        this.setHeaderHeight();
      }, { passive: true });
    }

    bindDelegatedClicks() {
      // Use capture phase to intercept clicks before other handlers
      document.addEventListener('click', (e) => {
        // Desktop: Column header toggle (collapse/expand models)
        const desktopColumnHeader = e.target.closest('.models-dropdown__column-header');
        if (desktopColumnHeader) {
          e.preventDefault();
          e.stopPropagation();
          this.toggleDesktopColumn(desktopColumnHeader);
          return;
        }
        
        // Desktop: Model header toggle (collapse/expand variants)
        const desktopModelHeader = e.target.closest('.models-dropdown__model-header');
        if (desktopModelHeader) {
          e.preventDefault();
          e.stopPropagation();
          this.toggleDesktopModel(desktopModelHeader);
          return;
        }

        // Mobile: Column header toggle
        const columnHeader = e.target.closest('.mobile-models-column__header');
        if (columnHeader) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.toggleMobileColumn(columnHeader);
          return;
        }

        // Mobile: Model group header toggle
        const mobileGroupHeader = e.target.closest('.mobile-models-group__header');
        if (mobileGroupHeader) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.toggleMobileGroup(mobileGroupHeader);
          return;
        }
      }, true); // Use capture phase
    }

    toggleDesktopColumn(button) {
      const column = button.closest('.models-dropdown__column');
      if (!column) return;

      const isExpanded = column.getAttribute('data-expanded') === 'true';
      column.setAttribute('data-expanded', String(!isExpanded));
      button.setAttribute('aria-expanded', String(!isExpanded));
    }

    toggleDesktopModel(button) {
      const model = button.closest('.models-dropdown__model');
      if (!model) return;

      const isExpanded = model.getAttribute('data-expanded') === 'true';
      model.setAttribute('data-expanded', String(!isExpanded));
      button.setAttribute('aria-expanded', String(!isExpanded));
    }

    toggleMobileColumn(header) {
      const column = header.closest('.mobile-models-column');
      if (!column) return;

      const content = column.querySelector('.mobile-models-column__content');
      if (!content) return;

      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      const willExpand = !isExpanded;
      
      // Update parent height BEFORE toggling state
      this.prepareParentHeight(header, willExpand);
      
      header.setAttribute('aria-expanded', String(willExpand));
      content.setAttribute('data-expanded', String(willExpand));
    }

    toggleMobileGroup(header) {
      const group = header.closest('.mobile-models-group');
      if (!group) return;

      const variants = group.querySelector('.mobile-models-group__variants');
      if (!variants) return;

      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      const willExpand = !isExpanded;
      
      // Update parent height BEFORE toggling state
      this.prepareParentHeight(header, willExpand);
      
      header.setAttribute('aria-expanded', String(willExpand));
      variants.setAttribute('data-expanded', String(willExpand));
    }
    
    /**
     * Prepare parent container height for smooth animation
     * Only set large height on expand - don't touch on collapse
     */
    prepareParentHeight(element, isExpanding) {
      // Only update parent when expanding to make room for content
      if (!isExpanding) return;
      
      const collapsibleContent = element.closest('.collapsible-menu-content');
      
      if (!collapsibleContent || !collapsibleContent.style.maxHeight) return;
      
      // Set parent to large height immediately so inner content can animate freely
      collapsibleContent.style.maxHeight = '5000px';
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.modelsMenuController = new ModelsMenuController();
    });
  } else {
    window.modelsMenuController = new ModelsMenuController();
  }
})();
